import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { URL_SERVER } from "../utils/Utils";
import secureLocalStorage from "react-secure-storage";
import { useJwt } from "react-jwt";
import { FileItem, FileWithFlag, FolderItem, FolderWithFlag, Item, ModalType, UsuarioShow } from "../utils/Types";
import { Claims } from "../security/ProtectedRouteAdmin";
import { useNightMode } from "../hooks/useNightMode";

import odpIcon from "../assets/img/ICON_ALIADAS/ODP/ODP_PURLPLE.png";
import odpIconDM from "../assets/img/ICON_ALIADAS/ODP/ODP_WHITE.png";

import odsIcon from "../assets/img/ICON_ALIADAS/ODS/ODS_PRUPLE.png";
import odsIconDM from "../assets/img/ICON_ALIADAS/ODS/ODS_WHITE.png";


import odtIcon from "../assets/img/ICON_ALIADAS/ODT/ODT_PURPLE.png";
import odtIconDM from "../assets/img/ICON_ALIADAS/ODT/ODT_WHITE.png";

import pdfIcon from "../assets/img/ICON_ALIADAS/PDF/PDF_#37285f.png";
import pdfIconDM from "../assets/img/ICON_ALIADAS/PDF/PDF_WHITE.png";

import pictureIcon from "../assets/img/ICON_ALIADAS/PICTURE/PICTURE_#37285f.png";
import pictureIconDM from "../assets/img/ICON_ALIADAS/PICTURE/PICTURE_WHITE.png";

import docIcon from "../assets/img/ICON_ALIADAS/DOC/DOC_37285F.png";
import docIconDM from "../assets/img/ICON_ALIADAS/DOC/DOC_WHITE.png";

import xmlIcon from "../assets/img/ICON_ALIADAS/XML/XML_37285F.png";
import xmlIconDM from "../assets/img/ICON_ALIADAS/XML/XML_WHITE.png";

import shareIcon from "../assets/img/ICON_ALIADAS/SHARE/SHARE_37285F.png"
import shareIconDM from "../assets/img/ICON_ALIADAS/SHARE/SHARE_WHITE.png"

import questionIcon from "../assets/img/ICON_ALIADAS/FAQ/FAQ_#37285f.png";
import { useTheme } from "../context/AppThemeContext";

export const useDashboardData = () => {
  const [nameSearch, setNameSearch] = useState<string>("");
  const [files, setFiles] = useState<FileItem[]>([]);
  const [folders, setFolders] = useState<FolderItem[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [newFolderName, setNewFolderName] = useState("");
  const [showPolicyModal, setShowPolicyModal] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const [viewMode, setViewMode] = useState<"list" | "grid">("list");
  const [openMenuKey, setOpenMenuKey] = useState<string | null>(null);
  const [showUploadFileModal, setShowUploadFileModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editName, setEditName] = useState("");
  const [editItemId, setEditItemId] = useState<string>("");
  const [editIsFolder, setEditIsFolder] = useState<boolean>(false);
  const [shareFile, setshareFile] = useState<string>("");
  const [shareEmail, setshareEmail] = useState("");
  const [showShareModal, setshowShareModal] = useState<boolean>(false);
  const [searchUser, setSearchUser] = useState<UsuarioShow | null>(null);

  const [shareMessage, setShareMessage] = useState<string>("");

  const [modalOpen, setModalOpen] = useState<ModalType | null>(null);

  const navigate = useNavigate();

  const storageToken = secureLocalStorage.getItem("token");
  const token = typeof storageToken === "string" ? storageToken : null;
  const { decodedToken } = useJwt<Claims>(token || "");
  const isAdmin = decodedToken?.role.name === "ROLE_ADMIN";

  const { isNight } = useTheme();

  const pdfActual = isNight ? pdfIcon : pdfIcon;
  const odtActual = isNight ? odtIcon : odtIcon;
  const odsActual = isNight ? odsIcon : odsIcon;
  const odpActual = isNight ? odpIcon : odpIcon;
  const pictureActual = isNight ? pictureIcon : pictureIcon;
  const docActual = isNight ? docIcon : docIcon;
  const xmlActual = isNight ? xmlIcon : xmlIcon;
  const shareActual = isNight ? shareIcon : shareIconDM;
  const questionMosaic = questionIcon;


  const mapFile = (f: any): FileItem => ({
  id: String(f.id),
  name: String(f.name),
  type: String(f.type),
  creation_date: f.creation_date,
  creation_user_id: Number(f.creation_user_id),
  shared_users: f.shared_users ?? [],
  folders: f.folders ?? [],
  last_update_date: f.last_update_date,
});

const mapFolder = (f: any): FolderItem => ({
  id: String(f.id),
  name: String(f.name),
  creation_user_id: Number(f.creation_user_id),
  creation_date: f.creation_date,
  last_update_date: f.last_update_date,

  // El backend utiliza "folders" para los hijos.
  // Nuestro frontend los llama "children".
  children: Array.isArray(f.folders)
    ? f.folders.map(mapFolder)
    : [],

  files: Array.isArray(f.files)
    ? f.files.map(mapFile)
    : [],
});
  useEffect(() => {
    // Esperamos a que el JWT esté disponible antes de cargar las carpetas.
    // Así isAdmin tiene su valor real y podemos elegir v2 o v3 correctamente.
    if (!token || !decodedToken) {
      return;
    }

    setNameSearch("");
    fetchData();
  }, [token, isAdmin, decodedToken]);

  
const fetchData = async (): Promise<void> => {
  try {
   const foldersUrl =
  `${URL_SERVER}/v3/folders/root`;

    const [filesResp, foldersResp] = await Promise.all([
      axios.get(`${URL_SERVER}/v2/files`, {
        headers: { Authorization: `Bearer ${token}` },
      }),

      axios.get(foldersUrl, {
        headers: { Authorization: `Bearer ${token}` },
      }),
    ]);

    setFiles(
      filesResp.data.data.map((f: any) => mapFile(f))
    );

    setFolders(
      foldersResp.data.data.map((f: any) => mapFolder(f))
    );

  } catch (err) {
    console.error("Error al obtener datos:", err);
  }
};
  const fetchDataFiltered = async (term: string): Promise<void> => {
    try {
      const [filesResp, foldersResp] = await Promise.all([
        axios.get(`${URL_SERVER}/v2/files/names/{name}?q=${term}`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
        axios.get(`${URL_SERVER}/v2/folders/names/{name}?q=${term}`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
      ]);

console.log("RESPUESTA CARPETAS:");
console.log(foldersResp.data);

console.log("CARPETAS DATA:");
console.log(foldersResp.data.data);

foldersResp.data.data.forEach((folder: any) => {
  console.log(
    "CARPETA:",
    folder.name,
    "ID:",
    folder.id,
    "HIJOS:",
    folder.folders
  );
});

   setFiles(
  filesResp.data.data.map((f: any) => mapFile(f))
);
     setFolders(
  foldersResp.data.data.map((f: any) => mapFolder(f))
);
    } catch (err) {
      console.error("Error al obtener datos:", err);
    }
  };

  const goToTrash = () => {
    navigate("/dashboardtrash");
  };

  const handleFolderClick = (folderId: string) => {
    navigate(`/dashboardfolder/${folderId}`);
  };

  const goToAdmin = () => {
    navigate("/admin");
  };

  const toggleItemMenu = (key: string) => {
    setOpenMenuKey((prev) => (prev === key ? null : key));
  };

  const handleDownload = async (fileId: string, fileName: string) => {
    try {
      if (!token) {
        return;
      }
      const response = await fetch(
        `${URL_SERVER}/v2/files/${fileId}/download`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "*/*",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Error al descargar el archivo");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleDelete = async (key: string, isFolder: boolean) => {
    try {
      await axios.delete(`${URL_SERVER}/v2/${isFolder ? "folders" : "files"}/${key}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (err) {
      console.error("Error al eliminar archivo:", err);
    }
    await fetchData();
    setOpenMenuKey(null);
  };

  const handleEdit = (key: string, isFolder: boolean, name: string) => {
    setEditItemId(key);
    setEditIsFolder(isFolder);
    setEditName(name);
    setShowEditModal(true);
    setOpenMenuKey(null);
  };

  const handleShare = (key: string, isFolder: boolean) => {
    setEditItemId(key);
    setEditIsFolder(isFolder);
    setshowShareModal(true);
  }

  const closeShareModal = () =>{
    setEditItemId("");
    setShareMessage("");
    setshareEmail("");
    setSearchUser(null);
    setshowShareModal(false);
  }
  const searchUserForShare = async (email: string) => {
    try {

      const response = await axios.get(`${URL_SERVER}/v2/users/email/${email}`,
        { headers: { Authorization: `Bearer ${token}` } },
      );


      if (response.data.data) {
        setSearchUser(response.data.data);
      }

    } catch (error) {
      console.error(error);
    }
  }

  const updateShare = async (itemId: string, isFolder: boolean, user: UsuarioShow) => {

    let dbItem;

    try {
      const response = await axios.get(`${URL_SERVER}/v2/${isFolder ? 'folders' : 'files'}/${itemId}`,
        { headers: { Authorization: `Bearer ${token}` } },

      );

      if (response.data.data) {
        dbItem = response.data.data;
      }

    } catch (error) {
      console.error(error);
    }


    try {

      let payload;

      if (isFolder) {
        payload = {
          foldersUsers: [user.id]
        }
      } else {
        payload = {
          filesUsers: [user.id]
        }
      }

      const response = await axios.put(`${URL_SERVER}/v2/${isFolder ? 'folders' : 'files'}/access/${itemId}`, payload,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      console.log(response.data);


      if (response.data) {
        setShareMessage("Exitosamente compartido con " + user.name + " " + user.surename);
      } else {
        setShareMessage("No se ha podido compartir con " + user.name + " " + user.surename);
      }

    } catch (error) {
      console.error(error);
    }
  }

  const openModal = (type: ModalType) => {
    setModalOpen(type);
    setshareFile("");
  }

  const closeModal = () => setModalOpen(null);


  /**
   * Funcion para seleccionar los iconos del modo mosaico
   * @param type tipo del fichero
   * @returns el icono
   */
  const getFileIcon = (type: string): string => {
    if (type === "application/pdf") return pdfActual;
    if (type === "application/vnd.oasis.opendocument.text") return odtActual;
    if (type === "application/vnd.oasis.opendocument.spreadsheet") return odsActual;
    if (type === "application/vnd.oasis.opendocument.presentation") return odpActual;
    if (type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") return docActual;
    if (type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") return xmlActual;
    if (type === "text/plain") return docActual;
    if (type.startsWith("image/")) return pictureActual;
    return questionMosaic;
  };

  /**
   * Constante para comprobar si los elementos son una carpeta o no
   */
  const allItems: Item[] = [
    ...folders.map(folder => ({ ...folder, isFolder: true } as FolderWithFlag)),
    ...files.map(file => ({ ...file, isFolder: false } as FileWithFlag)),
  ];

  

  return {
    nameSearch, setNameSearch,
    files, folders,
    showModal, setShowModal,
    newFolderName, setNewFolderName,
    showPolicyModal, setShowPolicyModal,
    sidebarOpen, setSidebarOpen,
    showOptions, setShowOptions,
    viewMode, setViewMode,
    openMenuKey, setOpenMenuKey,
    showUploadFileModal, setShowUploadFileModal,
    selectedFile, setSelectedFile,
    showEditModal, setShowEditModal,
    editName, setEditName,
    editItemId, setEditItemId,
    editIsFolder, setEditIsFolder,
    isAdmin,
    shareFile, setshareFile,
    modalOpen, setModalOpen,
    showShareModal, setshowShareModal,
    openModal, closeModal,
    fetchData,
    fetchDataFiltered,
    goToTrash,
    handleFolderClick,
    goToAdmin,
    toggleItemMenu,
    handleDownload,
    handleDelete,
    handleEdit,
    allItems,
    getFileIcon,
    searchUserForShare,
    searchUser,
    shareEmail,
    setshareEmail,
    updateShare,
    handleShare,
    navigate,
    storageToken,
    token,
    shareMessage,
    closeShareModal
  };
};